<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header">
        <h3>Value Assessments</h3>
    </div>
    <div class="panel-flat-body position-relative h-100" [formGroup]="form()">
        <div class="referral-field-grid">
            <label class="referral-field-label" for="appealMarketValue">Value/Assessment to Appeal</label>
            <referral-input-with-revert
                formControlName="appealMarketValue"
                [systemValue]="systemReferral()?.appealMarketValue"
                [originalValue]="originalReferral()?.appealMarketValue"
                [isNumber]="true"
                [maxlength]="15"
            />

            <label class="referral-field-label" for="appealTargetValue">
                Target Value/Assessment
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="appealTargetValue"
                [systemValue]="systemReferral()?.appealTargetValue"
                [originalValue]="originalReferral()?.appealTargetValue"
                [isNumber]="true"
                [maxlength]="15"
            />
            <label class="referral-field-label" for="issuesOnAppeal">Issues on Appeal</label>
            <referral-input-with-revert
                formControlName="issuesOnAppeal"
                [systemValue]="systemReferral()?.issuesOnAppeal"
                [originalValue]="originalReferral()?.issuesOnAppeal"
                [selectOptions]="issuesOnAppealOptions"
            />
            <label class="referral-field-label" for="nextAppealLevel">Appeal Level</label>
            <referral-input-with-revert
                formControlName="nextAppealLevel"
                [systemValue]="systemReferral()?.nextAppealLevel"
                [originalValue]="originalReferral()?.nextAppealLevel"
                [maxlength]="100"
            />
        </div>
    </div>
</div>
